<template>
  <div data-v-7a569d0e="" data-v-2ac6a5fc="" class="modifyPayPassword member">
    <form data-v-7a569d0e="">
      <div data-v-7a569d0e="" class="list">
        <div data-v-7a569d0e="" class="form-group-wrap">
          <div data-v-7a569d0e="" class="form-group">
            <label data-v-7a569d0e="">原资金密码</label>
            <div data-v-7a569d0e="" class="input-group">
              <input data-v-7a569d0e="" v-model="password" type="password"  placeholder="请输入原资金密码" />
            </div>
          </div>
          <div data-v-7a569d0e="" class="error-message" style="display: none"></div>
        </div>
        <div data-v-7a569d0e="" class="form-group-wrap">
          <div data-v-7a569d0e="" class="form-group">
            <label data-v-7a569d0e="">新资金密码</label>
            <div data-v-7a569d0e="" class="input-group">
              <input data-v-7a569d0e="" v-model="paypassword" type="password"  placeholder="密码由6位数字密码" />
            </div>
          </div>
          <div data-v-7a569d0e="" class="error-message" style="display: none"></div>
        </div>
        <div data-v-7a569d0e="" class="form-group-wrap">
          <div data-v-7a569d0e="" class="form-group">
            <label data-v-7a569d0e="" for="usdtAccountNo">确认密码</label>
            <div data-v-7a569d0e="" class="input-group">
              <input data-v-7a569d0e="" v-model="paypassword1" type="password"  placeholder="请再次输入密码" />
            </div>
          </div>
          <div data-v-7a569d0e="" class="error-message" style="display: none"></div>
        </div>
      </div>
      <p data-v-7a569d0e="">无法修改资金密码，<a data-v-7a569d0e="" @click="$parent.openKefu">联系客服</a></p>
      <a data-v-7a569d0e="" class="form-button" @click="isOk">确认</a>
    </form>
    <div data-v-7a569d0e="" class="pay-dialog" style="display: none">
      <div data-v-7a569d0e="" slot="alertContent" class="pay-password">
        <div data-v-7a569d0e="" class="pay-password__header">提示</div>
        <p data-v-7a569d0e="" class="pay-password__title"><span data-v-7a569d0e="">请您先绑定手机号后，再设置资金密码</span></p>
        <div data-v-7a569d0e=""><a data-v-7a569d0e="" href="javascript:void (0);" class="pay-password__button">前往设置</a></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modifyPayPassword',
  data() {
    return {
      password: null,
      paypassword: null,
      paypassword1: null,
    };
  },
  created() {
    let that = this;
  },
  methods: {
    isOk() {
      let that = this;
      let info = {};

      //资金密码
      let url = '/api/editPayPassword';
      info.password = that.password;
      info.paypassword = that.paypassword;
      if (!that.password) {
        that.$parent.showTost(0, '请输入旧密码');
        return;
      }
      if (!that.paypassword) {
        that.$parent.showTost(0, '请输入新密码');
        return;
      }
      if (that.password.length < 6) {
        that.$parent.showTost(0, '请输入正确的旧密码长度');
        return;
      }
      if (that.paypassword.length < 6) {
        that.$parent.showTost(0, '请输入正确的新密码长度');
        return;
      }
      if (!that.paypassword1) {
        that.$parent.showTost(0, '请输入确认密码');
        return;
      }
      if (that.paypassword1 != that.paypassword) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      if (that.password == that.paypassword) {
        that.$parent.showTost(0, '新旧密码不能一致！');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun.post(url, info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
        }
        if (res.code == 200) {
          that.$parent.showTost(1, res.message);
          that.$parent.getUserInfos();
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-7d43975c.12f60d5e.css';
</style>



// WEBPACK FOOTER //
// src/components/main/modifyPayPassword.vue